import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=5c93d833&"
import script from "./Speakers.vue?vue&type=script&setup=true&lang=js&"
export * from "./Speakers.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports